const handleResponseError = async (response: Response) => {
    const statusCode = response.status;
    let errorMessage = 'An error occurred';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let errorData: any;

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        try {
            errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (error) {
            // If JSON parsing fails, fall back to text
            errorMessage = (await response.text()) || errorMessage;
        }
    } else {
        errorMessage = (await response.text()) || errorMessage;
    }

    // Handle specific HTTP status codes
    switch (statusCode) {
        case 413:
            errorMessage =
                'Payload too large. Please reduce the size of your request.';
            break;
        case 429:
            errorMessage = 'Too many requests. Please try again later.';
            break;
        case 500:
            errorMessage = 'Internal server error. Please try again later.';
            break;
        case 503:
            errorMessage = 'Service unavailable. Please try again later.';
            break;
    }

    throw new Error(`${statusCode}: ${errorMessage}`);
};

export default handleResponseError;
